import { useState, useEffect } from 'react';
import api from './api';
import { useAuth } from './AuthContext';

export function Equipment() {
    const [items, setItems] = useState([]);
    const [itemName, setItemName] = useState('');
    const [category, setCategory] = useState('Guitar');
    const { user } = useAuth();
    const isAdmin = user?.role === 'admin';

    const categories = ['Guitar', 'Bass', 'Drums', 'Vocals', 'Amps', 'Cables', 'Other'];

    const load = () => {
        api.get('/equipment').then((res) => setItems(res.data));
    };

    useEffect(() => { load(); }, []);

    const addItem = async (e) => {
        e.preventDefault();
        if (!itemName) return;
        await api.post('/equipment', { item_name: itemName, category });
        setItemName('');
        load();
    };

    const deleteItem = async (id) => {
        await api.delete(`/equipment/${id}`);
        load();
    };

    const groupedByUser = () => {
        const groups = {};
        items.forEach((item) => {
            const key = item.username || 'me';
            if (!groups[key]) groups[key] = [];
            groups[key].push(item);
        });
        return groups;
    };

    return (
        <div className="equipment-page">
            <h2>Equipment</h2>

            <form onSubmit={addItem} className="add-equipment-form">
                <select value={category} onChange={(e) => setCategory(e.target.value)}>
                    {categories.map((c) => <option key={c} value={c}>{c}</option>)}
                </select>
                <input
                    placeholder="Item name"
                    value={itemName}
                    onChange={(e) => setItemName(e.target.value)}
                />
                <button type="submit">Add Item</button>
            </form>

            {isAdmin ? (
                Object.entries(groupedByUser()).map(([username, userItems]) => (
                    <div key={username} className="equipment-user-group">
                        <h3>{username}</h3>
                        {userItems.map((item) => (
                            <div key={item.id} className="equipment-item">
                                <span>[{item.category}] {item.item_name}</span>
                                <button onClick={() => deleteItem(item.id)}>Delete</button>
                            </div>
                        ))}
                    </div>
                ))
            ) : (
                <div className="equipment-list">
                    {items.map((item) => (
                        <div key={item.id} className="equipment-item">
                            <span>[{item.category}] {item.item_name}</span>
                            <button onClick={() => deleteItem(item.id)}>Delete</button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
